/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Small_Ibex_RoamInputs */

const fr_salty_small_ibex_roam = /** @type {(inputs: Salty_Small_Ibex_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favicon`)
};

/**

* @param {Salty_Small_Ibex_RoamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_small_ibex_roam = /** @type {((inputs?: Salty_Small_Ibex_RoamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Small_Ibex_RoamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_small_ibex_roam(inputs)
});